import bookingInstance from '@/lib/axios/booking-instance';
import type { IBaseResponse } from '@/types/base-response';
import type { QueryFunctionContext } from '@tanstack/react-query';
import { AxiosError } from 'axios';

const handleRequest = async <T = IBaseResponse<Record<string, unknown>>>(
  req: Promise<{ data: T }>
): Promise<T> => {
  try {
    const res = await req;
    return res.data;
  } catch (err) {
    if (err instanceof AxiosError) {
      throw err.response?.data;
    }
    throw err;
  }
};

const baseApiFactory = <TEntity, TSchema>(apiUrl: string) => ({
  getList: ({
    queryKey,
  }: QueryFunctionContext): Promise<IBaseResponse<TEntity[]>> =>
    handleRequest(bookingInstance.get(apiUrl, { params: queryKey[1] })),

  getDetail: ({
    queryKey,
  }: QueryFunctionContext): Promise<IBaseResponse<TEntity>> =>
    handleRequest(bookingInstance.get(`${apiUrl}/${queryKey[1]}`)),

  create: (data: TSchema) => handleRequest(bookingInstance.post(apiUrl, data)),

  edit: ({ id, data }: { id: string; data: TSchema }) =>
    handleRequest(bookingInstance.put(`${apiUrl}/${id}`, data)),

  delete: (id: string) =>
    handleRequest(bookingInstance.delete(`${apiUrl}/${id}`)),
});

export { baseApiFactory, handleRequest };
